module.exports = {
          srcSet: __webpack_public_path__ + "c1a07df477175c0c20188dea55a63cb2-29.png"+" 29w",
          images:[ {path: __webpack_public_path__ + "c1a07df477175c0c20188dea55a63cb2-29.png",width: 29,height: 28}],
          src: __webpack_public_path__ + "c1a07df477175c0c20188dea55a63cb2-29.png",
          toString:function(){return __webpack_public_path__ + "c1a07df477175c0c20188dea55a63cb2-29.png"},
          
          width: 29,
          height: 28
        }